import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import moment from 'moment';
import _ from 'lodash';
import { numberFormat, toBuddhistYear } from 'utils/app.utils';

const ExportToExcel = async ({
    medicineExport,
    productExport,
    materialExport,
    branches,
    branchId,
    rangeDate,
    t,
    productTypeSelected,
}: any) => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet(t('REPORT.REPORT_NAME.SALE_SUMMARY_MONTHLY'));

    sheet.addRow([t('REPORT.REPORT_NAME.SALE_SUMMARY_MONTHLY')]);
    sheet.getRow(1).font = { bold: true, size: 16 };
    sheet.mergeCells('A1:N1');
    sheet.getCell('A1').alignment = { horizontal: 'center' };
    sheet.addRow([
        t('REPORT.FILTER.BRANCH'),
        _.find(branches, (b) => b.branchId === branchId)?.branchName ||
        _.find(branches, (b) => b.branchId === branchId)?.branchNameEn ||
        '-',
        t('REPORT.FILTER.DATE_START'),
        `${t('REPORT.FILTER.DATE_START')}: ${rangeDate[0] ? toBuddhistYear(moment(rangeDate[0]), 'DD/MM/YYYY') : '-'}`,
        t('REPORT.FILTER.DATE_END'),
        `${t('REPORT.FILTER.DATE_END')}: ${rangeDate[1] ? toBuddhistYear(moment(rangeDate[1]), 'DD/MM/YYYY') : '-'}`,
        t('REPORT.FILTER.OPERATIVE_TYPE'),
        `${t('REPORT.FILTER.OPERATIVE_TYPE')}: ${productTypeSelected.productTypeName}`,
    ]);
    sheet.mergeCells('B2:C2');
    sheet.mergeCells('D2:E2');
    sheet.mergeCells('F2:G2');
    sheet.mergeCells('H2:I2');

    sheet.getColumn('A').width = 5;   // ลำดับ
    sheet.getColumn('B').width = 20;  // วันที่
    sheet.getColumn('C').width = 15;  // เลขที่ใบเสร็จ
    sheet.getColumn('D').width = 10;  // รหัสผู้ป่วย
    sheet.getColumn('E').width = 15;  // รหัสผู้ป่วยในสาขา
    sheet.getColumn('F').width = 25;  // ชื่อผู้ป่วย
    sheet.getColumn('G').width = 15;  // ประเภทรายการ
    sheet.getColumn('H').width = 30;  // รายการ
    sheet.getColumn('I').width = 12;  // ราคาต่อหน่วย
    sheet.getColumn('J').width = 8;   // จำนวน
    sheet.getColumn('K').width = 10;  // ส่วนลด
    sheet.getColumn('L').width = 10;  // ส่วนเพิ่ม
    sheet.getColumn('M').width = 12;  // ราคาสุทธิ
    sheet.getColumn('N').width = 12;  // ราคาจ่ายจริง

    const createTable = (startRow: any, title: any, headers: any, tableData: any) => {

        sheet.addRow([title]);
        sheet.getRow(startRow).font = { size: 12 };

        sheet.addRow(headers);
        sheet.getRow(startRow + 1).font = { bold: true, size: 12 };
        sheet.getRow(startRow + 1).alignment = { horizontal: 'center' };


        if (title === t('REPORT.TITLE.SUM')) {
            tableData.forEach((item: any) => {
                const row = [
                    item.no,
                    item.group === "MATERIAL" ? t('INVENTORY.GROUP.MATERIAL') : (item.group === "PRODUCT" ? t('INVENTORY.GROUP.PRODUCT') : t('INVENTORY.GROUP.MEDICINE')),
                    item.itemTypeName,
                    item.itemName || '-',
                    numberFormat(item.qty) ?? 0,
                    numberFormat(item.discount) ?? 0,
                    numberFormat(item.additional) ?? 0,
                    numberFormat(item.total) ?? 0,
                    numberFormat(item.amountPaid) ?? 0,
                ];
                sheet.addRow(row);
            });
        }

        if (title !== t('REPORT.TITLE.SUM')) {
            tableData.forEach((item: any, index: any) => {
                const num = index + 1;
                const row = [
                    num,
                    item.createdAt,
                    item.billNo,
                    item.cnNumber,
                    item.branchCnNumber,
                    item.fullName,
                    item.productTypeName,
                    item.itemName || '-',
                    numberFormat(item.price) ?? 0,
                    item.qty ?? 0,
                    numberFormat(item.discount) ?? 0,
                    numberFormat(item.additional) ?? 0,
                    numberFormat(item.total) ?? 0,
                    numberFormat(item.amountPaid) ?? 0,
                ];
                const addedRow = sheet.addRow(row);
                addedRow.getCell(2).numFmt = '@';
            });
            const sumRow = startRow + 2 + tableData.length;
            sheet.addRow([t('REPORT.TITLE.SUM')]);
            sheet.mergeCells(`A${sumRow}:H${sumRow}`);

            const excelRow = sheet.getRow(sumRow);
            console.log(sumRow, excelRow, startRow)
            if (tableData.length > 0) {
                const sum = tableData.reduce((acc: any, cur: any) => {
                    return {
                        price: acc.price + (cur.price || 0),
                        qty: acc.qty + (cur.qty || 0),
                        discount: acc.discount + (cur.discount || 0),
                        additional: acc.additional + (cur.additional || 0),
                        total: acc.total + (cur.total || 0),
                        amountPaid: acc.amountPaid + (cur.amountPaid || 0),
                    };
                }, { price: 0, qty: 0, discount: 0, additional: 0, total: 0, amountPaid: 0 });
                sheet.getCell(`I${sumRow}`).value = numberFormat(sum.price);
                sheet.getCell(`J${sumRow}`).value = numberFormat(sum.qty);
                sheet.getCell(`K${sumRow}`).value = numberFormat(sum.discount);
                sheet.getCell(`L${sumRow}`).value = numberFormat(sum.additional);
                sheet.getCell(`M${sumRow}`).value = numberFormat(sum.total);
                sheet.getCell(`N${sumRow}`).value = numberFormat(sum.amountPaid);
            } else {
                sheet.getCell(`I${sumRow}`).value = 0;
                sheet.getCell(`J${sumRow}`).value = 0;
                sheet.getCell(`K${sumRow}`).value = 0;
                sheet.getCell(`L${sumRow}`).value = 0;
                sheet.getCell(`M${sumRow}`).value = 0;
                sheet.getCell(`N${sumRow}`).value = 0;
            }

            sheet.getRow(sumRow).font = { bold: true, size: 12 };
            sheet.getCell(`A${sumRow}`).alignment = { horizontal: 'right' };
            sheet.getCell(`I${sumRow}`).alignment = { horizontal: 'right' };
            sheet.getCell(`J${sumRow}`).alignment = { horizontal: 'right' };
            sheet.getCell(`K${sumRow}`).alignment = { horizontal: 'right' };
            sheet.getCell(`L${sumRow}`).alignment = { horizontal: 'right' };
            sheet.getCell(`M${sumRow}`).alignment = { horizontal: 'right' };
            sheet.getCell(`N${sumRow}`).alignment = { horizontal: 'right' };
            return sumRow + 2;
        }
    };

    const summarizeData = () => {
        const summary: any = [];
        const groupSum = _.groupBy([...medicineExport, ...productExport, ...materialExport], 'itemName');
        for (const key in groupSum) {
            if (Object.prototype.hasOwnProperty.call(groupSum, key)) {
                const list = groupSum[key];
                summary.push({
                    no: summary.length + 1,
                    group: list.length ? list[0].group : '',
                    itemTypeName: list.length ? list[0].productTypeName : '',
                    itemName: key,
                    qty: _.sumBy(list, 'qty') || 0,
                    discount: _.sumBy(list, 'discount') || 0,
                    additional: _.sumBy(list, 'additional') || 0,
                    total: _.sumBy(list, 'total') || 0,
                    amountPaid: _.sumBy(list, 'amountPaid') || 0,
                });
            }
        }
        return summary;
    };

    const summaryHeaders = [
        t('REPORT.TABLE.OPERATIVE_SUMMARY_MONTH.#NO'),
        t('INVENTORY.GROUP.CATEGORY'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.TYPE'),
        t('REPORT.TABLE.OPERATIVE_SUMMARY_MONTH.LIST'),
        t('REPORT.TABLE.OPERATIVE_SUMMARY_MONTH.QTY'),
        t('REPORT.TABLE.OPERATIVE_SUMMARY_MONTH.DISCOUNT'),
        t('REPORT.TABLE.OPERATIVE_SUMMARY_MONTH.ADDITIONAL'),
        t('REPORT.TABLE.OPERATIVE_SUMMARY_MONTH.TOTAL_PRICE'),
        t('REPORT.TABLE.OPERATIVE_SUMMARY_MONTH.TOTAL_PAID'),
    ];

    const medicineHeaders = [
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.#NO'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.DATE'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.BILL_NO'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.CN_NUMBER'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.BRANCH_CN_NUMBER'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.PATIENT_NAME'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.TYPE'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.LIST'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.PRICE'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.QTY'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.DISCOUNT'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.ADDITIONAL'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.TOTAL'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.AMOUNT_PAID'),
    ];

    const productHeaders = [
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.#NO'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.DATE'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.BILL_NO'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.CN_NUMBER'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.BRANCH_CN_NUMBER'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.PATIENT_NAME'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.TYPE'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.LIST'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.PRICE'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.QTY'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.DISCOUNT'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.ADDITIONAL'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.TOTAL'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.AMOUNT_PAID'),
    ];

    const materialHeaders = [
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.#NO'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.DATE'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.BILL_NO'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.CN_NUMBER'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.BRANCH_CN_NUMBER'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.PATIENT_NAME'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.TYPE'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.LIST'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.PRICE'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.QTY'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.DISCOUNT'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.ADDITIONAL'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.TOTAL'),
        t('REPORT.TABLE.SALE_SUMMARY_MONTH.AMOUNT_PAID'),
    ];

    let currentRow = 3;
    currentRow = createTable(currentRow, t('REPORT.TABLE.SALE_SUMMARY_MONTH.MED'), medicineHeaders, medicineExport);
    currentRow = createTable(currentRow, t('REPORT.TABLE.SALE_SUMMARY_MONTH.PD'), productHeaders, productExport);
    currentRow = createTable(currentRow, t('REPORT.TABLE.SALE_SUMMARY_MONTH.MAT'), materialHeaders, materialExport);


    const summaryData = summarizeData();
    currentRow = createTable(currentRow, t('REPORT.TITLE.SUM'), summaryHeaders, summaryData);

    const buffer = await workbook.xlsx.writeBuffer();
    const timestamp = moment().format('YYYYMMDD_HHmmss');
    const blob = new Blob(
        [buffer],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
    );
    saveAs(
        blob,
        `${t('REPORT.REPORT_NAME.SALE_SUMMARY_MONTHLY')}_${timestamp}.xlsx`
    );
};

export default ExportToExcel;
